/** Types */
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_REQUEST_SUCCESS = 'GET_ORDERS_REQUEST_SUCCESS';

export const SINGLE_ORDERS_REQUEST = 'SINGLE_ORDERS_REQUEST';
export const SINGLE_ORDERS_SUCCESS = 'SINGLE_ORDERS_SUCCESS';


